import { createSidexEnvironment } from './environment.shared';

const entraTenantId = '5dbf1add-202a-4b8d-815b-bf0fb024e033';
const entraClientId = '407351e3-20f0-4d06-bcf1-ea52d60fc70b';

const apiUrls = {
    user: 'https://api.dev.sidex-inspect.siemens-healthineers.com/v1/users',
    scd: 'https://api.dev.sidex-inspect.siemens-healthineers.com/v1/scd',
    order: 'https://api.dev.sidex-inspect.siemens-healthineers.com/v1/orders',
    employee: 'https://api.dev.sidex-inspect.siemens-healthineers.com/v1/employees'
};

export const environment = createSidexEnvironment({
    production: true,
    apiUrls,
    entra: {
        clientId: entraClientId,
        tenantId: entraTenantId
    }
});
